// Display-only exam-time formatting. Never touches the stored values, the
// countdown, timezone handling, or any comparison logic — it only changes how a
// time is SHOWN to the student.

/**
 * Format a wall-clock time string ("HH:MM" or "HH:MM:SS") as 12-hour with an
 * Arabic AM/PM marker (ص/م). Pure string math — no Date, no timezone — so it
 * never reinterprets the value through the device's local timezone.
 *
 *   "00:00:00" → "12:00 ص"
 *   "12:00:00" → "12:00 م"
 *   "23:00:00" → "11:00 م"
 *   "23:30:00" → "11:30 م"
 */
export function formatTime12(time) {
  if (time == null || time === '') return '';
  const parts = String(time).split(':');
  let h = parseInt(parts[0], 10);
  if (Number.isNaN(h)) return String(time);
  const m = String(parts[1] ?? '00').padStart(2, '0').slice(0, 2);
  const period = h < 12 ? 'ص' : 'م'; // AM = ص, PM = م
  let h12 = h % 12;
  if (h12 === 0) h12 = 12;
  return `${h12}:${m} ${period}`;
}
